import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

import stringUtils from 'utils/String';
import localeUtils from 'utils/LanguageLocale';
import resourceWrapper from 'utils/framework/resourceWrapper';
import TextZoneEN from 'components/RwdBasket/Carts/AutoreplenishCart/TextZone/locales/TextZone_en_US';
import TextZoneFR from 'components/RwdBasket/Carts/AutoreplenishCart/TextZone/locales/TextZone_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;

function TextZone({ isSignedIn, totalAnnualReplenishmentDiscount, firstName, hasAcceleratedPromotionItems }) {
    const getText = resourceWrapper(getLocalisedDataFromResource(TextZoneEN, TextZoneFR));
    const boldRedText = `*{color:red}${totalAnnualReplenishmentDiscount}{color}*`;

    return (
        <>
            {isSignedIn
                ? getText(
                    hasAcceleratedPromotionItems ? 'signedInFirstYearSavingsMessage' : 'signedInSavingsMessage',
                    true,
                    stringUtils.capitalize(firstName),
                    boldRedText
                )
                : getText(hasAcceleratedPromotionItems ? 'guestFirstYearSavingsMessage' : 'guestSavingsMessage', true, boldRedText)}
        </>
    );
}

export default wrapFunctionalComponent(TextZone, 'TextZone');
